export const SERVER_ENDPOINT = process.env.REACT_APP_SERVER_ENDPOINT;
